const DataValidation = {

	matchPasswordPattern(password) {
		let regexList = [".*[A-Z].*", ".*[a-z].*", ".*\\d.*", ".*[`~!@#$%^&*()\\-_=+\\\\|\\[{\\]};:'\",<.>/?].*"];
		let resultList = [];
		let message = "Hasło powinno zawierać co najmniej ";
		if (password.length < 10) {
			resultList.push("10 znaków");
		}
		if (password.match(regexList[0]) === undefined || password.match(regexList[0]) === null) {
			resultList.push("jedną dużą literę");
		}
		if (password.match(regexList[1]) === undefined || password.match(regexList[1]) === null) {
			resultList.push("jedną małą literę");
		}
		if (password.match(regexList[2]) === undefined || password.match(regexList[2]) === null) {
			resultList.push("jedną cyfrę");
		}
		if (password.match(regexList[3]) === undefined || password.match(regexList[3]) === null) {
			resultList.push("jeden znak specjalny");
		}
		if (resultList[0] === null || resultList[0] === undefined) {
			return "OK";
		}
		return message.concat(resultList.join(", "));
	},

	validPassword(password, passwordConfirmation) {
		if (password !== passwordConfirmation) {
			return "Podane hasła muszą być identyczne";
		}
		return this.matchPasswordPattern(password);
	}

};

export default DataValidation;
